import s from './CustomButton.module.scss';
import {TCustomButtonProps} from "@/app/[locale]/common/components/CustomButton/types";

export const CustomButton = ({ size = 'large', type = 'fullWidth', children, disabled = false, className = '', onClick }: TCustomButtonProps) => {
    return (
        <button
            disabled={disabled}
            className={`${s.customButton} ${className} ${s[size]} ${s[type]} ${disabled ? s.disabledButton : ''}`}
            onClick={onClick}>{ children }</button>
    );
};